//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// chrome-feedback imports
import { IProps, IState } from "./ChromeFeedback.d";
import * as s from "./ChromeFeedback.styles";
import { menuItemIcon } from "@components/chrome-menu-drawer/ChromeMenuDrawer.styles";
// util
import { track, TrackingEvents } from "@util/analytics.util";
// material-ui
import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { Feedback } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class ChromeFeedbackCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private onClick = () => {
    track(TrackingEvents.CHROME_MENU.CLICK_FEEDBACK);
    window.open("https://support.getclockwise.com/hc/en-us/requests/new", "_blank");
  };

  public render() {
    return (
      <MenuItem style={this.props.style} onClick={() => this.onClick()} cw-id="chrome-feedback">
        <ListItemIcon>
          <Feedback {...menuItemIcon} style={this.props.iconStyle} />
        </ListItemIcon>
        <ListItemText inset primary="Contact support" />
      </MenuItem>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const ChromeFeedback = withStyles(s.styles)(ChromeFeedbackCmpt);
